import React from 'react';
import NewErrorIcon from 'src/assets/images/iconsMvpApp/Error.svg';
import NewErrorExclamation from 'src/assets/images/iconsMvpApp/ErrorExclamation.svg';
import { t } from 'i18next';

export const ErrorIcon = () => {
  const isFromMvpApp = globalThis.location.pathname.includes('/app');
  return (
    <img
      src={isFromMvpApp ? NewErrorExclamation : NewErrorIcon}
      alt={t('Error')}
      style={{
        width: '25px',
        height: '25px',
      }}
    />
  );
};
